export const FAMILY_FORGE = 53;

export const FORGE_ACTION_STATUS = 1;
export const FORGE_ACTION_UPGRADE = 2;
export const FORGE_ACTION_ADD_ELEMENT = 3;
export const FORGE_ACTION_REMOVE_ELEMENT = 4;
export const FORGE_ACTION_ADD_RANDOM_STAT = 5;

export type ForgeSlotKey =
  | 'weapon'
  | 'armor'
  | 'shield'
  | 'hat'
  | 'boots'
  | 'gloves';

export const FORGE_SLOT_CODES: Record<ForgeSlotKey, number> = {
  weapon: 1,
  armor: 2,
  shield: 3,
  hat: 4,
  boots: 5,
  gloves: 6,
};

export const FORGE_ACTION_RECYCLE = 6;
export const FORGE_ACTION_RESET_STATS = 7;
